import { render, staticRenderFns } from "./MobileMenuList.vue?vue&type=template&id=052bcda0"
import script from "./MobileMenuList.vue?vue&type=script&lang=js"
export * from "./MobileMenuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports